import template from './scoresheet_menu.html'
import './scoresheet_menu.css'

export default {
  template,
  controller: 'scoresheetMenuController as scoresheetMenu'
}
